import {getKeycloak, setKeycloak} from "@/components/auth/keycloak";

const MIN_VALIDITY_TIME = 5;

export function getValidToken(): Promise<string | undefined> {
  const keycloak = getKeycloak();
  if (keycloak.isTokenExpired(MIN_VALIDITY_TIME)) {
    return new Promise((resolve, reject) => {
      keycloak.updateToken(MIN_VALIDITY_TIME)
          .success((refreshed: boolean) => {
            if (refreshed) {
              setKeycloak(keycloak);
            }
            resolve(keycloak.token);
          })
          .error(() => {
            keycloak.login();
            reject();
          });
    });
  }
  return Promise.resolve(keycloak.token);
}



// WEBPACK FOOTER //
// ./src/components/auth/token.ts